import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../services/api-service.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultationSessionsService {

  constructor(private _apiService: ApiServiceService) { }



  GetSessionsList(model: any) {
    return this._apiService.get(`${environment.apiUrl}/appointments-request`, model)
      .pipe(catchError(this.handleError));
  }

  GetSpecialties() {
    return this._apiService.get(`${environment.apiUrl}/specialties`)
      .pipe(catchError(this.handleError));
  }

  GetRequestDetails(id: string) {
    return this._apiService.get(`${environment.apiUrl}/appointments-request/${id}`)
      .pipe(catchError(this.handleError));
  }


  handleError(error: any) {
    return throwError(error);
  }
}
